// extracted by mini-css-extract-plugin
export default {"cardClass1":"ProductSalesChart_cardClass1__CYgK4"};